import { Action } from '@ngrx/store';
import { DepartamentsBusinessColor } from '@app/models/departamentsBusinessColor';

export enum DepartamentsBusinessColorActionTypes {
  Load = '[DepartamentsBusinessColor] Load',
  LoadSuccess = '[DepartamentsBusinessColor] Load Success',
  LoadFail = '[DepartamentsBusinessColor] Load Fail',

  Create = '[DepartamentsBusinessColor] Create departamentsBusinessColor',
  CreateSuccess = '[DepartamentsBusinessColor] Create departamentsBusinessColor success',
  CreateFail = '[DepartamentsBusinessColor] Create departamentsBusinessColor fail',

  AddOne = '[DepartamentsBusinessColor] Add one',
  AddAll = '[DepartamentsBusinessColor] Add all',

  Update = '[DepartamentsBusinessColor] Update departamentsBusinessColor',
  UpdateSuccess = '[DepartamentsBusinessColor] Update departamentsBusinessColor success',
  UpdateFail = '[DepartamentsBusinessColor] Update departamentsBusinessColor fail',
  UpdateOne = '[DepartamentsBusinessColor] Update one',

  Delete = '[DepartamentsBusinessColor] delete',
  DeleteSuccess = '[DepartamentsBusinessColor] delete success',
  DeleteFail = '[DepartamentsBusinessColor] delete fail'
}

export class Load implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.LoadSuccess;
  constructor(public departamentsBusinessColor: DepartamentsBusinessColor[]) {}
}

export class LoadFail implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.Create;
  constructor(public departamentsBusinessColor: DepartamentsBusinessColor) {}
}

export class CreateSuccess implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.CreateSuccess;
  constructor(public departamentsBusinessColor: DepartamentsBusinessColor) {}
}

export class CreateFail implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.CreateFail;
  constructor(public error: any) {}
}
export class AddAll implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.AddAll;
  constructor(public departamentsBusinessColor: DepartamentsBusinessColor[]) {}
}

export class AddOne implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.AddOne;
  constructor(public departamentsBusinessColor: DepartamentsBusinessColor) {}
}
export class Update implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.Update;
  constructor(
    public id: number,
    public departamentsBusinessColor: DepartamentsBusinessColor
  ) {}
}
export class UpdateFail implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class UpdateSuccess implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.UpdateSuccess;
  constructor(public id: number, public data: any) {}
}

export class UpdateOne implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.UpdateOne;
  constructor(public departamentsBusinessColor: DepartamentsBusinessColor) {}
}

export class Delete implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.Delete;
  constructor(public id: number) {}
}

export class DeleteSuccess implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.DeleteSuccess;
  constructor(public id: number) {}
}
export class DeleteFail implements Action {
  readonly type = DepartamentsBusinessColorActionTypes.DeleteFail;
  constructor(public error: any) {}
}

export type DepartamentsBusinessColorActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | Create
  | CreateSuccess
  | CreateFail
  | AddOne
  | AddAll
  | Update
  | UpdateFail
  | UpdateSuccess
  | UpdateOne
  | Delete
  | DeleteSuccess
  | DeleteFail;
